import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromOrganization from './organization.reducer';
import { OrganizationEffects } from './organization.effects';
import { OrganizationFacade } from './organization.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromOrganization.ORGANIZATION_FEATURE_KEY,
      fromOrganization.reducer
    ),
    EffectsModule.forFeature([OrganizationEffects]),
  ],
  providers: [OrganizationFacade],
})
export class OrganizationStateModule {}
